module.exports = __webpack_public_path__ + "img/pointer.13f4b934.png";